import { render, staticRenderFns } from "./Automation.vue?vue&type=template&id=dae6b864&scoped=true&"
import script from "./Automation.vue?vue&type=script&lang=js&"
export * from "./Automation.vue?vue&type=script&lang=js&"
import style0 from "./Automation.vue?vue&type=style&index=0&id=dae6b864&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dae6b864",
  null
  
)

export default component.exports